<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="secondary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Equipos ({{equipos.length}}/{{equiposTodos.length}})</ion-title>
    </ion-toolbar>
    <ion-progress-bar v-if="cargando" type="indeterminate"></ion-progress-bar>
  </ion-header>
  <ion-content class="content">
    <ion-searchbar debounce="200" :value="filtro" v-on:ionChange="filtrar($event.detail.value)" placeholder="Buscar"></ion-searchbar>
    <ion-list v-if="esMovil">
      <ion-item-sliding v-for="u in equipos" :key="u._id">
        <ion-item v-on:click="ver(u._id)">
          <ion-thumbnail slot="end" v-if="u.imagenes && u.imagenes[0] && u.imagenes[0].imagen">
            <ion-img :src="cdn+u.imagenes[0].imagen"></ion-img>
          </ion-thumbnail>
          <ion-label text-wrap>
            <h2>{{u.alias || u.nombre || u.sn}}</h2>
            <p>{{u.tipo}} {{u.marca}} {{u.modelo}} {{u.sn}}</p>
            <p v-if="u.cliente && u.cliente.nombre">{{u.cliente.nombre}}</p>
          </ion-label>
        </ion-item>
        <ion-item-options slot="end">
          <ion-item-option color="danger" v-if="yo.rol=='administrador'" @click="eliminar(u)">
            <i class="icon ion-ios-trash"></i>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </ion-list>
    <div v-else>
      <table class="tablaEquipos">
        <thead>
          <tr>
            <th @click="ordenarPor('tipo')">Tipo</th>
            <th @click="ordenarPor('marca')">Marca</th>
            <th @click="ordenarPor('modelo')">Modelo</th>
            <th @click="ordenarPor('sn')">SN</th>
            <th @click="ordenarPor('alias')">Inventario</th>
            <th @click="ordenarPor('nombreCliente')">Cliente</th>
            <th>...</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="e in equipos" :key="e._id">
            <td>{{e.tipo}}</td>
            <td>{{e.marca}}</td>
            <td>{{e.modelo}}</td>
            <td>{{e.sn}}</td>
            <td>{{e.alias}}</td>
            <td>{{(e.cliente||{}).nombre}}</td>
            <td>
              <ion-button size="small" color="primary" @click="ver(e._id)" fill="clear">
                <i class="icon ion-ios-create icon-sm"></i>
              </ion-button>
              <ion-button size="small" color="danger" @click="eliminar(e)" fill="clear" v-if="yo.rol=='administrador'">
                <i class="icon ion-ios-trash icon-sm"></i>
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <ion-item lines="none">
        <ion-label>&nbsp;</ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>&nbsp;</ion-label>
      </ion-item>
    </div>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="ver('0')">
        <i class="icon icon-lg ion-ios-add"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<style>
.tablaEquipos {
  width: 100%;
  overflow-x: auto;
}

.tablaEquipos th,
.tablaEquipos td {
  text-align: left;
}
</style>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'CatalogoEquipos',
  data() {
    return {
      esMovil: Api.esMovil(),
      yo: Api.fetchLocal('cmms.yo') || {},
      cdn: Api.cdn + '/',
      cargando: true,
      filtro: '',
      equiposLimite: 20,
      equiposTodos: [],
      equipos: [],
      orden: 'marca',
      sentido: 1
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    ver(id) {
      this.$router.push('/catalogos/equipos/' + id)
    },
    async obtener() {
      this.cargando = true
      try {
        let clientes = (await Api.get('cliente'))
        let clientesIndice = {}
        for (let cl of clientes)
          clientesIndice[cl._id] = cl
        console.log("clientes?", clientes.length)
        this.equiposTodos = (await Api.get('equipo'))
          .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
          .map(e => {
            if (e.idCliente && clientesIndice[e.idCliente]) {
              e.cliente = clientesIndice[e.idCliente]
              e.nombreCliente = clientesIndice[e.idCliente].nombre
            }
            return e
          })
        console.log("equiposTodos?", this.equiposTodos.slice(0, 10))
      } catch (e) {
        toast("No se pudieron obtener los equipos")
        console.error("EEQUIPOS", e)
      }
      this.filtrar('')
      this.cargando = false
    },
    async eliminar(e) {
      if (true == confirm('¿Desea eliminar este equipo? Esto no se puede deshacer')) {
        await Api.delete('equipo', e._id)
        toast("Eliminado")
        await Api.wait(1000)
        this.obtener()
      }
    },
    filtrar(str) {
      str = (str || '').toUpperCase()
      this.filtro = str
      if (this.filtro == '')
        this.equipos = JSON.parse(JSON.stringify(this.equiposTodos))
        .splice(0, this.equiposLimite)
      else {
        this.equipos = this.equiposTodos
          .filter(e => {
            let strMaestra = ''
            for (let prop of ['nombre', 'nombreCliente', 'marca', 'modelo', 'area', 'tipo', 'sn'])
              strMaestra += (e[prop] || '').toUpperCase()
            return strMaestra.indexOf(str) >= 0
          })
      }
      console.log("Filtrar", str, this.equipos.length)
    },
    ordenarPor(prop = '') {
      this.orden = prop
      const sentido = this.sentido * (-1)
      this.sentido = sentido
      this.equipos = this.equipos
        .sort((a, b) => a[prop] > b[prop] ? sentido : sentido * (-1))
    }
  },
  async mounted() {
    this.obtener()
    if (false) {
      await Api.wait(2000)
      for (let p of this.equiposTodos)
        if (p.importado && p.importado > 0)
          await Api.delete('equipo', p._id)
    }
  }
}
</script>
